var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAlertCircle = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M1 12c0 6.1 4.9 11 11 11s11-4.9 11-11S18.1 1 12 1 1 5.9 1 12m2 0c0-5 4-9 9-9s9 4 9 9-4 9-9 9-9-4-9-9m10 0V8c0-.6-.4-1-1-1s-1 .4-1 1v4c0 .6.4 1 1 1s1-.4 1-1m-.3 4.7c-.2.2-.4.3-.8.3-.3 0-.5-.1-.7-.3s-.3-.4-.3-.7c0-.117.034-.2.063-.269A.4.4 0 0 0 11 15.6c0-.1.1-.2.2-.3.3-.3.7-.4 1.1-.2.05 0 .075.025.1.05s.05.05.1.05c.1 0 .2.1.2.1.05.05.075.1.1.15s.05.1.1.15c.1.1.1.3.1.4 0 .05-.025.125-.05.2a.8.8 0 0 0-.05.2c0 .1-.1.2-.2.3",
  clipRule: "evenodd"
})));
export default SvgAlertCircle;